import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { SessionAuditService } from './session-audit.service';

/**
 * Runs before the application renders but does not block it. The service waits
 * for a confirmed sign-in before calling the backend, because with
 * `autoSignIn: true` the user is often unauthenticated at this point and the
 * page is about to be discarded by the MSAL redirect.
 */
export function provideSessionAudit(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(SessionAuditService).initialize();
  });
}
